import { render, staticRenderFns } from "./fl44-unknown-volume-purchase-contract-info.vue?vue&type=template&id=7feb65c6&"
import script from "./fl44-unknown-volume-purchase-contract-info.vue?vue&type=script&lang=js&"
export * from "./fl44-unknown-volume-purchase-contract-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7feb65c6')) {
      api.createRecord('7feb65c6', component.options)
    } else {
      api.reload('7feb65c6', component.options)
    }
    module.hot.accept("./fl44-unknown-volume-purchase-contract-info.vue?vue&type=template&id=7feb65c6&", function () {
      api.rerender('7feb65c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-purchase-contract-info.vue"
export default component.exports